import { Navigate, Route, Routes } from 'react-router-dom';
import {
    FaqPage,
    HelpCenterPage,
    HelpDocumentDetailPage,
    ResourcesConfigProvider,
    ResourcesOverviewPage,
    ResourcesShell,
    VideoDetailPage,
    VideosPage
} from '@odo/resources-ui';
import apiV2 from '../api/v2';
import { useMyPermissions } from '../hooks/useMyPermissions';
import { SidebarLayout } from '../layouts/SidebarLayout';

/**
 * Mirrors the dashboard's resources section: one `ResourcesShell` around all
 * pages so the content lists load once and ⌘K search works from any depth.
 * `homePath` and `documentTitleSuffix` are the only things that differ between
 * the two apps.
 *
 * Authoring is the one thing files-viewer has that the dashboard does not, and
 * it is not "admin" here: `resources.update` / `resources.delete` come from the
 * `resources.manager` bundle, held by ODO Account Manager and ODO Super Admin.
 * The flags only decide which controls render — the v2 content write routes
 * enforce the same two permissions server-side, so a reader who reaches the page
 * by URL still cannot write.
 */
export const ResourcesRoutes = () => {
    const { hasPermission } = useMyPermissions();

    return (
        <ResourcesConfigProvider
            api={apiV2}
            homePath="/home"
            documentTitleSuffix="ODO Admin"
            reserveTopRight
            canEdit={hasPermission('resources.update')}
            canDelete={hasPermission('resources.delete')}
        >
            <SidebarLayout hideHeader overlayAvatar>
                <ResourcesShell>
                    <Routes>
                        <Route path="" element={<ResourcesOverviewPage />} />
                        <Route path="faq" element={<FaqPage />} />
                        <Route path="videos" element={<VideosPage />} />
                        <Route path="videos/:slug" element={<VideoDetailPage />} />
                        <Route path="help-center" element={<HelpCenterPage />} />
                        <Route path="help-center/:slug" element={<HelpDocumentDetailPage />} />

                        <Route path="*" element={<Navigate to="/resources" replace />} />
                    </Routes>
                </ResourcesShell>
            </SidebarLayout>
        </ResourcesConfigProvider>
    );
};
